// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/chunks/" + {"28591":"YoastFaq","67002":"SearchBar-vue","78483":"DkButton-vue"}[chunkId] + ".4.17.4.css"; };